// shared components
import { DataGridToolbar } from '@/components/ui/datagrid/DataGridToolbar';

// feature-components
import {
  ExpandCollapseButton,
  FavoritesButton,
  FullscreenButton,
} from '@/features/energyxplorer/portfolio/components/datagrid/PortfolioToolbarButtons';

interface Props {
  handleFavoritesFilterClick: (value: boolean) => void;
  isFavoritesFiltered: boolean;
  setIsFavoritesFiltered: (value: boolean) => void;
  handleExpandCollapse: () => void;
  isCollapsed: boolean;
}

const PortfolioAnalysisCombinedToolbar = ({
  handleFavoritesFilterClick,
  isFavoritesFiltered,
  setIsFavoritesFiltered,
  handleExpandCollapse,
  isCollapsed,
}: Props) => {
  const handleFavoritesToggle = (newValue: boolean) => {
    handleFavoritesFilterClick(newValue);
    setIsFavoritesFiltered(newValue);
  };

  return (
    <DataGridToolbar
      showColumns
      showFilters
      showExport
      showExcelExport
      showQuickFilter
      showDivider
    >
      <FullscreenButton />
      <ExpandCollapseButton
        isCollapsed={isCollapsed}
        onToggle={handleExpandCollapse}
      />
      <FavoritesButton
        isFavoritesFiltered={isFavoritesFiltered}
        onToggle={handleFavoritesToggle}
      />
    </DataGridToolbar>
  );
};

export default PortfolioAnalysisCombinedToolbar;
